import React from 'react';
import './FlooringSection.css';

const PLANCHER_MESSAGE = 'Bois franc canadien à partir de 3,99 $';

function FlooringSection() {
  return (
    <section className="flooring-section" id="plancher">
      <div className="container">
        <div className="section-header">
          <h2>Plancher</h2>
          <p className="section-subtitle">Découvrez nos différentes essences de bois</p>
        </div>

        <div className="flooring-price-banner">
          <p>{PLANCHER_MESSAGE}</p>
        </div>

        <div className="flooring-description">
          <p>
            Vous cherchez du Plancher pour votre Maison, Bureau ou autre?
            Vous êtes un Contracteur qui cherche du plancher pour votre client?
          </p>
          <p>
            Que ce soit Bois Franc, Flottant ou Vinyl,
            Vous êtes à la bonne place! Plancher à Prix Abordable &
            Économique avec plusieurs choix de couleur.
            Disponible aussi produit Haut de Gamme "Select".
          </p>
        </div>
      </div>
    </section>
  );
}

export default FlooringSection;
